$('.testimonials-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  $('.home-product-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  $(document).ready(function(){
    $('.product_images').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.product_ws_thumbnails',
      responsive: [
        {
            breakpoint: 767,
            settings: {
              fade: false,
              arrows: false
            }
        }    
      ]
    });
    $('.product_ws_thumbnails').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product_images',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
          }
        },
        {
          breakpoint: 1199,
          settings: {
          }
        },
        {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false,
            }
        },
        
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    });
  
  function account_page(evt, account_data) {
    var i, ws_tabs_body, account_tabs_links;
    ws_tabs_body = document.getElementsByClassName("ws_tabs_body");
    for (i = 0; i < ws_tabs_body.length; i++) {
      ws_tabs_body[i].style.display = "none";
    }
    account_tabs_links = document.getElementsByClassName("account_tabs_links");
    for (i = 0; i < account_tabs_links.length; i++) {
      account_tabs_links[i].className = account_tabs_links[i].className.replace(" active", "");
    }
    document.getElementById(account_data).style.display = "block";
    evt.currentTarget.className += " active";
  }

  if(getParameterByName('click') == 'true'){
    $('.addresses-link').trigger('click');
  }
  function getParameterByName(name){
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  $(document).ready(function(){
    $('.accordion-tab').click(function(e){
      e.preventDefault();
      $('.panel').slideUp('slow');
      if($(this).next('.panel').is(':visible')){
        $(this).removeClass('active');
        $(this).next('.panel').slideUp('slow');
      } else{
        $(this).addClass('active');
        $(this).next('.panel').slideDown('slow');
      }
    })
  })